import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Summary broadcasts replace this button while the details keep their state.
    this.button = this.element.querySelector("button[aria-controls]")
    if (!this.button) return
    this.details = this.button.getAttribute("aria-controls").split(" ")
      .map(id => document.getElementById(id)).filter(Boolean)
    const empty = this.element.querySelector("[data-agenda-empty]")
    empty?.classList.toggle("show", this.details.some(detail => detail !== empty && detail.classList.contains("show")))
    this.sync = this.sync.bind(this)
    this.details.forEach(detail => {
      detail.addEventListener("shown.bs.collapse", this.sync)
      detail.addEventListener("hidden.bs.collapse", this.sync)
    })
    this.sync()
  }

  disconnect() {
    this.details?.forEach(detail => {
      detail.removeEventListener("shown.bs.collapse", this.sync)
      detail.removeEventListener("hidden.bs.collapse", this.sync)
    })
  }

  sync() {
    this.button.setAttribute("aria-expanded", String(this.details.some(detail => detail.classList.contains("show"))))
  }
}
